"use client";

import { App } from "@capacitor/app";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { getAppRouteFromUrl, isNativeClerkCallbackUrl } from "@/lib/client/appUrl";
import { isNativeCapacitorApp } from "@/lib/client/capacitor";

export default function CapacitorAppUrlListener() {
  const router = useRouter();

  useEffect(() => {
    if (!isNativeCapacitorApp()) {
      return;
    }

    let isMounted = true;

    const handleUrl = (rawUrl?: string | null) => {
      if (!isMounted || !rawUrl) {
        return;
      }

      // MainActivity hands Clerk callbacks to the native SDK. Navigating the
      // same URL to the ClerkJS callback page would start a second web flow.
      if (isNativeClerkCallbackUrl(rawUrl)) {
        return;
      }

      const route = getAppRouteFromUrl(rawUrl);

      if (route) {
        router.replace(route);
      }
    };

    void App.getLaunchUrl().then((launchUrl) => {
      handleUrl(launchUrl?.url);
    });

    const listenerPromise = App.addListener("appUrlOpen", ({ url }) => {
      handleUrl(url);
    });

    return () => {
      isMounted = false;
      void listenerPromise.then((listener) => listener.remove());
    };
  }, [router]);

  return null;
}
